<style lang="less" scoped>
    .tabs {
      width: 100%;
    //   flex-grow: 1;
      height: 55px;
    //   background: rgba(0, 0, 0, 0) !important;
    //   border: none !important;
      line-height: 55px;
      display: flex;
      flex-direction: row;
      color: #8F9BB3;
      border-bottom: 1px solid #EAF1FF;
      .tab_con{
        // width: 25%;
        // width: 75px;
        font-weight: 600;
        font-size: 12px;
        height: 55px;
        padding:0 20px ;
        text-align: center;
        // padding-bottom: 10px;
        cursor: pointer;
        
        .selectActive{
        //   width: 30%;
          height: 55px;
          padding:0 20px ;
          margin: 0 auto;
          color: #000;
          font-size: 14px;
          font-weight: 600;
          border-bottom:3px solid #3291F8;
        }
      }
    }
</style>

<template>
    <div class="list-container">
        <div class="list-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="listBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="list-content-div">
            <div class="tabs">
                <div v-for="(item, index) in tabList" :key="index" class="tab_con" @click="tabChange(item)">
                    <div :class="{'selectActive' : item.value == tabSelect}">{{item.label}}</div>
                </div>
            </div>
            <!-- 充电桩信息 -->
            <pileDetail v-if="tabSelect == 1"></pileDetail>
            <!-- 充电信息 -->
            <chargeList v-if="tabSelect == 2"></chargeList>
            <!-- 报文日志 -->
            <logList v-if="tabSelect == 3"></logList>
            <!-- 故障信息 -->
            <faultList v-if="tabSelect == 4"></faultList>
            <!-- 用户信息 -->
            <userList v-if="tabSelect == 5"></userList>
            <!-- 私桩共享信息 -->
            <publicPileDetail v-if="tabSelect == 6"></publicPileDetail>
            <!-- 私桩预约充电 -->
            <reservationList v-if="tabSelect == 7"></reservationList>
            <!-- 私桩升级 -->
            <updateList v-if="tabSelect == 8"></updateList>
            <!-- 预约信息 -->
            <reservationInfo v-if="tabSelect == 9"></reservationInfo>
        </div>
    </div>
</template>

<script>
// import custDetail from '../cust-manage/cust-detail.vue';
import chargeList from '../cust-manage/charge-list.vue';
import pileDetail from './pile-detaill.vue';
import logList from './log-list.vue';
import faultList from './fault-list.vue';
import userList from './user-list.vue';
import updateList from './update-list.vue';
import reservationInfo from './reservation-info.vue';
import reservationList from './reservation-list.vue';
import publicPileDetail from '../../charging-manage/pile-charge/public-charge-data/pile-datail.vue';
// import relativesDetail from './relativesDetail/relatives-friends-manage.vue';
// import formMould from '../../components/form/index';
// import payDetail from './pay-detail.vue';
// import integralDetail from './integral-detail.vue';
// import publicPileDetail from '../charging-manage/pile-charge/public-charge-data/pile-datail.vue';
    // import pageConfig from './page-config';
    export default {
    components: {
        chargeList,
        pileDetail,
        logList,
        faultList,
        userList,
        publicPileDetail,
        updateList,
        reservationList,
        reservationInfo,
    },
        data() {
            
            return {
                listBreadCrumb : [{
                        type: 'title',
                        name: '首页',
                    },
                    {
                        type: 'router',
                        name: ' 充电桩设备列表',
                        router: 'pileList'
                    },
                    {
                        type: 'title',
                        name: '详情',
                    }],
                tabList: [
                    {
                        value: 1,
                        label: '充电桩信息'
                    },
                    {
                        value: 2,
                        label: '充电信息'
                    },
                    {
                        value: 3,
                        label: '报文日志'
                    },
                    {
                        value: 4,
                        label: '故障信息'
                    },
                    {
                        value: 5,
                        label: '用户信息'
                    },
                    {
                        value: 6,
                        label: '私桩共享信息'
                    },
                    {
                        value: 7,
                        label: '私桩预约充电'
                    },
                    {
                        value: 8,
                        label: '私桩升级'
                    },
                    {
                        value: 9,
                        label: '预约信息'
                    },
                ],
                checkList:[],
                tabSelect: 1,
                }
            },
        methods: {
            //执行表格数据函数 角色状态下拉框
            init() {},
            tabChange(tab) {
                this.listBreadCrumb[1].name = tab.label
                this.tabSelect = tab.value
                console.log(tab);
            },
        },
        mounted() {
            this.tabSelect = this.$route.query.parent||'1'
            this.init();
        },
        destroyed(){
            this.$store.commit('setPileObj', null);
            this.$store.commit('setCustObj', null);
        }
    }
</script>